module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMzY2IiBoZWlnaHQ9IjU2MC4xODMiIHZpZXdCb3g9IjAgMCAxMzY2IDU2MC4xODMiPjxkZWZzPjxzdHlsZT4uYXtmaWxsOiNmYmY0ZDI7fTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJhIiBkPSJNMCwwSDEzNjZWNDA1Ljc3NnMtNTYuMTU4LDE3LjU0Ny0zNDguMjc1LTU3LjJTNjE4LjM1NCw0MjQuMTEzLDQ5MS4xNDgsNTA0LjhDMjI2LjY5LDY3Mi41MzcsMCw0MDUuNzc2LDAsNDA1Ljc3NloiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/bg_landingpage.svg
// module id = 1228
// module chunks = 0